export const SET_FIRST_PAGE_SEGEMENTS = 'PRO/SET_FIRST_PAGE_SEGEMENTS'
export type SET_FIRST_PAGE_SEGEMENTS = typeof SET_FIRST_PAGE_SEGEMENTS
